(() => {
  angular
    .module('gm.common.directives')
    .directive('gmPrintButton', gmPrintButtonDirective);

  function gmPrintButtonDirective(
    $window
  ) {
    'ngInject';

    function printHTML() {
      $window.print();
    }

    return {
      restrict: 'E',
      templateUrl: 'modules/common/directives/print-button/print-button.html',
      transclude: true,

      link(scope, element, attrs) {
        element.on('click', () => {
          if (attrs.load) {
            scope.$eval(attrs.load, {
              callback: printHTML
            });
          } else {
            printHTML();
          }
        });
      },
    };
  }
})();
